import { render, staticRenderFns } from "./Submenus.vue?vue&type=template&id=2860d400&scoped=true"
import script from "./Submenus.vue?vue&type=script&lang=js"
export * from "./Submenus.vue?vue&type=script&lang=js"
import style0 from "./Submenus.vue?vue&type=style&index=0&id=2860d400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2860d400",
  null
  
)

export default component.exports